<div class="flex flex-row p-4 m-auto max-w-[1600px] sticky top-16 lg:top-24 bg-white z-30 border-b border-primary-600 gap-4 items-center">
  <app-search-box></app-search-box>
  <div class="flex flex-row">
    @if (!(website.observeAuthenticated() | async)) {
      <button
        (click)="website.login()"
        class="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-primary-600 py-2 pl-2 pr-4 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
        aria-label="Login"
      >
        <ng-icon name="heroArrowLeftOnRectangle" class="flex-shrink-0 text-white mr-1" size="24px"></ng-icon>
        Login
      </button>
    } @else {
      <button class="flex flex-row cursor-pointer p-2 text-gray-500 hover:text-primary-500" (click)="website.logout()" aria-label="Logout">
        <ng-icon name="heroArrowRightOnRectangle" class="flex-shrink-0" size="24px"></ng-icon>
      </button>

      <a [routerLink]="['/account']" class="flex flex-row p-2 text-gray-500 hover:text-primary-500">
        <span class="sr-only">Account</span>
        <ng-icon name="heroUserCircle" class="flex-shrink-0" size="24px"></ng-icon>
      </a>
    }

    <a class="flex flex-row p-2 text-gray-500 hover:text-primary-500" [routerLink]="['/shop/cart']" aria-label="Warenkorb">
      <ng-icon name="heroShoppingBag" class="flex-shrink-0" size="24px"></ng-icon>
      <span class="ml-2 text-sm font-medium flex items-center">{{ cart.observePositionCount() | async }}</span>
    </a>
  </div>
</div>
<div class="flex flex-row px-2 lg:px-8 m-auto max-w-[1600px] pb-6 py-6">
  <div class="hidden md:flex md:w-[220px] pt-2">
    <app-side-nav class="w-full mr-4"></app-side-nav>
  </div>
  <div class="flex flex-1 md:ml-6 max-w-full">
    <router-outlet></router-outlet>
  </div>
</div>
